
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('rating-star-ribbon')]),_c('path',{attrs:{"d":"M19.059,23.105l-6.177-4.492a1.5,1.5,0,0,0-1.764,0L4.941,23.105A.75.75,0,0,1,3.75,22.5V2.25A1.5,1.5,0,0,1,5.25.75h13.5a1.5,1.5,0,0,1,1.5,1.5V22.5A.75.75,0,0,1,19.059,23.105Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M12.53,5.791l1.249,2.458h2.127a.582.582,0,0,1,.419,1l-1.953,1.922,1.082,2.485a.589.589,0,0,1-.839.737L12,12.918,9.385,14.389a.589.589,0,0,1-.839-.737l1.082-2.485L7.675,9.245a.582.582,0,0,1,.419-1h2.127L11.47,5.791A.594.594,0,0,1,12.53,5.791Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    